import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BoilerIconService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/room-temperature/set-point-card/boiler-icon/boiler-icon.service';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-boiler-icon',
  templateUrl: './boiler-icon.component.html',
  styleUrls: ['./boiler-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoilerIconComponent {

  viewModel$ = combineLatest({
    boilerOn: this.boilerIconService.boilerOn$,
  });

  constructor(
    public sidebarRoomService: SidebarRoomService,
    private boilerIconService: BoilerIconService,
  ) {}
}
